export enum BackButtonDataHooks {
  BACK_BUTTON = 'back-button',
  BACK_BUTTON_TOOLTIP = 'back-button-tooltip',
}
